import ChevronLeftIcon from '@mui/icons-material/ChevronLeftRounded';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppRoutes } from '../../../constants/routes';
import { Namespace } from '../../../locales/translations';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { Link } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import { SelectedAwarenessCampaignActions } from '../../../store/reducers/awareness_campaigns/selected';
import { useAmbassadorMissionCompleted } from '../../../hooks/awarenessCampaigns';

export default function AwarenessCampaignDetailHeader() {

    const { t } = useTranslation([Namespace.ADDRESSES, Namespace.DATES]);

    const selectedCampaign = useAppSelector(state => state.awareness_campaign.selected.selectedAwarenessCampaign);

    const isCompleted = useAmbassadorMissionCompleted();

    const dispatch = useAppDispatch();

    if (!selectedCampaign) return null;

    return (
        <Box>
            <Box display="flex" alignItems="center" gap={2}>
                <Link to={`/${AppRoutes.AWARENESS_CAMPAIGNS}`}>
                    <IconButton>
                        <ChevronLeftIcon />
                    </IconButton>
                </Link>
                <Typography variant="h4" gutterBottom sx={{ pb: 1.5, flexGrow: 1 }}>
                    {selectedCampaign.name}
                </Typography>

                <IconButton 
                    color="success"
                    disabled={isCompleted}
                    onClick={() => dispatch(SelectedAwarenessCampaignActions.setConfirmCompleteDialogOpen(true))}
                >
                    {isCompleted ? (
                        <CheckCircleRoundedIcon />
                    ) : (
                        <CheckCircleOutlineIcon />
                    )}
                </IconButton>
            </Box>

            <Box px={7}>
                <Typography variant="body2" fontStyle="italic">
                    {t('created_at', { ns: Namespace.DATES, date: selectedCampaign.createdAt })}
                </Typography>
                <Typography variant="body1" fontWeight="bold" gutterBottom>
                    {t('deadline', { ns: Namespace.DATES, date: selectedCampaign.deadline })}
                </Typography>
            </Box>
        </Box>
    );
}